import UA from '../const/ua.js';

const IS_ANDROID = /android/i.test(UA);
export default IS_ANDROID;
